import { PayloadAction } from "@reduxjs/toolkit";

import { Types } from "../../../../services";
import { PaymentSpreads } from "../../../../utils/types";

export const pending = (state: PaymentSpreads) => {
  state.isLoading = true;
  state.data = null;
  state.isError = false;
};

export const fulfilled = (
  state: PaymentSpreads,
  action: PayloadAction<
    Types.ApiResponse<Types.PaymentSpreadTypes.PaymentSpread[]>
  >
) => {
  state.isLoading = false;
  state.isError = false;
  state.isSuccess = action.payload.success;
  state.data = action.payload.response;
};

export const rejected = (state: PaymentSpreads) => {
  state.isLoading = false;
  state.isError = true;
  state.isSuccess = false;
};
